"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RedwoodApolloProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _FetchConfigProvider = require("./FetchConfigProvider");

var _GraphQLHooksProvider = require("./GraphQLHooksProvider");

var _flash = require("../flash");

const ApolloProviderWithFetchConfig = ({
  config = {},
  children
}) => {
  const {
    uri,
    headers
  } = (0, _FetchConfigProvider.useFetchConfig)();
  const client = new _client.ApolloClient({
    cache: new _client.InMemoryCache(),
    uri,
    headers,
    ...config
  });
  return /*#__PURE__*/_react.default.createElement(_client.ApolloProvider, {
    client: client
  }, children);
};

const RedwoodApolloProvider = ({
  graphQLClientConfig,
  useAuth,
  children
}) => {
  return /*#__PURE__*/_react.default.createElement(_FetchConfigProvider.FetchConfigProvider, {
    useAuth: useAuth
  }, /*#__PURE__*/_react.default.createElement(ApolloProviderWithFetchConfig, {
    config: graphQLClientConfig
  }, /*#__PURE__*/_react.default.createElement(_GraphQLHooksProvider.GraphQLHooksProvider, {
    useQuery: _client.useQuery,
    useMutation: _client.useMutation
  }, /*#__PURE__*/_react.default.createElement(_flash.FlashProvider, null, children))));
};

exports.RedwoodApolloProvider = RedwoodApolloProvider;